import i18n from 'translations';

const changeLanguage = lng => {
  i18n.changeLanguage(lng);
};

export default changeLanguage;
